export const maxDigitsIfDecimal = (num: number, decimals: number): string => {
    return num.toFixed(decimals).replace(/0+$/, '').replace(/\.$/, '');
}